import { render, staticRenderFns } from "./txs_pending.vue?vue&type=template&id=e480d250&"
import script from "./txs_pending.vue?vue&type=script&lang=js&"
export * from "./txs_pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports